import * as homeApi from "./home";
import * as userApi from "./user";
import * as adminApi from "./admin";
import * as chapterApi from "./chapter";

export const API = {
  home: homeApi,
  user: userApi,
  admin: adminApi,
  chapter: chapterApi
};
